const americasRecipes = [
  // ==================== AMERICAN (7) ====================
  {
    title: 'Classic Cheeseburger',
    description:
      'A juicy, perfectly seasoned beef patty topped with melted cheddar, crisp lettuce, and tangy pickles on a toasted brioche bun. This iconic American classic delivers the ultimate backyard cookout experience.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/classic-cheeseburger.jpg', caption: 'Finished cheeseburger with all the fixings', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/classic-cheeseburger-prep.jpg', caption: 'Seasoned beef patties ready for the grill', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 10,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Dinner', 'Lunch', 'Family Meals'],
    tags: ['grilling', 'family-friendly', 'under-30-min', 'comfort-food', 'game-day', 'high-protein'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',
    nutrition: {
      calories: 540,
      protein: 32,
      carbs: 34,
      fat: 30,
      fiber: 2,
      sugar: 6,
      sodium: 820,
      iron: 4.5,
    },
    ingredients: [
      { qty: 1.5, unit: 'lb', item: 'ground beef (80/20)', group: 'Patties' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Patties' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Patties' },
      { qty: 1, unit: 'tsp', item: 'garlic powder', group: 'Patties' },
      { qty: 1, unit: 'tsp', item: 'onion powder', group: 'Patties' },
      { qty: 4, unit: 'slices', item: 'sharp cheddar cheese', group: 'Toppings' },
      { qty: 4, unit: '', item: 'brioche buns', group: 'Toppings' },
      { qty: 4, unit: 'leaves', item: 'iceberg lettuce', group: 'Toppings' },
      { qty: 1, unit: '', item: 'tomato, sliced', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'dill pickle slices', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'ketchup', group: 'Condiments' },
      { qty: 2, unit: 'tbsp', item: 'yellow mustard', group: 'Condiments' },
    ],
    steps: [
      { order: 1, instruction: 'In a large bowl, gently mix the ground beef with salt, pepper, garlic powder, and onion powder. Divide into 4 equal portions and shape into patties slightly wider than the buns, making a small indent in the center of each.', timerMinutes: null },
      { order: 2, instruction: 'Preheat a grill or cast-iron skillet over high heat. Cook patties for 4 minutes on the first side without pressing down.', timerMinutes: 4 },
      { order: 3, instruction: 'Flip the patties and immediately place a slice of cheddar on each. Cook for another 3-4 minutes for medium doneness.', timerMinutes: 4 },
      { order: 4, instruction: 'During the last minute of cooking, place the brioche buns cut-side down on the grill to toast lightly.', timerMinutes: 1 },
      { order: 5, instruction: 'Assemble burgers: spread ketchup and mustard on the bottom bun, add lettuce, the cheesy patty, tomato slices, and pickles. Close with the top bun and serve immediately.', timerMinutes: null },
    ],
    notes: 'For a smash burger variation, use a flat-top griddle and press the patties thin with a spatula right after placing them down. Let the cheese melt by covering with a dome or aluminum foil for the last 30 seconds.',
    communityRating: 4.7,
    communityRatingCount: 420,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'New England Clam Chowder',
    description:
      'A rich and creamy soup loaded with tender clams, chunky potatoes, and smoky bacon, simmered to velvety perfection. This New England staple warms you from the inside out on chilly coastal evenings.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/new-england-clam-chowder.jpg', caption: 'Bowl of creamy clam chowder with oyster crackers', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/new-england-clam-chowder-prep.jpg', caption: 'Diced potatoes and chopped clams', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 35,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 0,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Soups & Stews', 'Dinner'],
    tags: ['one-pot', 'comfort-food', 'high-protein', 'weeknight-dinner', 'freezer-friendly'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 380,
      protein: 18,
      carbs: 30,
      fat: 22,
      fiber: 2,
      sugar: 4,
      sodium: 890,
      iron: 2.8,
    },
    ingredients: [
      { qty: 4, unit: 'slices', item: 'thick-cut bacon, chopped', group: 'Chowder' },
      { qty: 2, unit: 'tbsp', item: 'unsalted butter', group: 'Chowder' },
      { qty: 1, unit: 'cup', item: 'diced yellow onion', group: 'Chowder' },
      { qty: 2, unit: 'stalks', item: 'celery, diced', group: 'Chowder' },
      { qty: 3, unit: 'tbsp', item: 'all-purpose flour', group: 'Chowder' },
      { qty: 2, unit: 'cups', item: 'clam juice', group: 'Chowder' },
      { qty: 1.5, unit: 'cups', item: 'whole milk', group: 'Chowder' },
      { qty: 1, unit: 'cup', item: 'heavy cream', group: 'Chowder' },
      { qty: 1.5, unit: 'lb', item: 'Yukon Gold potatoes, diced', group: 'Chowder' },
      { qty: 2, unit: 'cans (6.5 oz each)', item: 'chopped clams, drained (reserve liquid)', group: 'Chowder' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'fresh thyme leaves', group: 'Seasonings' },
      { qty: 0.5, unit: 'tsp', item: 'white pepper', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Seasonings' },
    ],
    steps: [
      { order: 1, instruction: 'In a large Dutch oven over medium heat, cook the bacon until crispy, about 6 minutes. Remove the bacon with a slotted spoon and set aside, leaving the rendered fat in the pot.', timerMinutes: 6 },
      { order: 2, instruction: 'Add butter to the bacon fat. Once melted, add onion and celery. Cook until softened, about 5 minutes, stirring occasionally.', timerMinutes: 5 },
      { order: 3, instruction: 'Sprinkle flour over the vegetables and stir constantly for 1 minute to cook out the raw flour taste.', timerMinutes: 1 },
      { order: 4, instruction: 'Slowly whisk in the clam juice, reserved clam liquid, and milk. Add potatoes, bay leaves, and thyme. Bring to a simmer and cook until potatoes are fork-tender, about 15 minutes.', timerMinutes: 15 },
      { order: 5, instruction: 'Stir in the heavy cream, chopped clams, white pepper, and salt. Simmer gently for 5 minutes without boiling to let the flavors meld.', timerMinutes: 5 },
      { order: 6, instruction: 'Remove bay leaves. Ladle into bowls and top with the crispy bacon. Serve with oyster crackers on the side.', timerMinutes: null },
    ],
    notes: 'For a thicker chowder, mash some of the potatoes against the side of the pot with a wooden spoon. Fresh littleneck clams can replace canned: steam 3 dozen open, chop the meat, and use the steaming liquid as part of your clam juice.',
    communityRating: 4.6,
    communityRatingCount: 280,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Buffalo Wings',
    description:
      'Crispy, deep-fried chicken wings tossed in a fiery cayenne-butter sauce and served with creamy blue cheese dressing and crunchy celery sticks. The ultimate game-day crowd-pleaser straight from Buffalo, New York.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/buffalo-wings.jpg', caption: 'Sauced buffalo wings with blue cheese dip', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/buffalo-wings-prep.jpg', caption: 'Wings seasoned and ready for frying', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 3,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Appetizers', 'Snacks'],
    tags: ['high-protein', 'game-day', 'party', 'gluten-free', 'comfort-food'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 480,
      protein: 34,
      carbs: 3,
      fat: 36,
      fiber: 0,
      sugar: 1,
      sodium: 1100,
      iron: 1.8,
    },
    ingredients: [
      { qty: 3, unit: 'lb', item: 'chicken wings, split into flats and drumettes', group: 'Wings' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Wings' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Wings' },
      { qty: 1, unit: 'tsp', item: 'garlic powder', group: 'Wings' },
      { qty: 0.5, unit: 'cup', item: "Frank's RedHot sauce", group: 'Buffalo Sauce' },
      { qty: 0.33, unit: 'cup', item: 'unsalted butter, melted', group: 'Buffalo Sauce' },
      { qty: 1, unit: 'tbsp', item: 'white vinegar', group: 'Buffalo Sauce' },
      { qty: 0.25, unit: 'tsp', item: 'cayenne pepper', group: 'Buffalo Sauce' },
      { qty: 6, unit: 'stalks', item: 'celery, cut into sticks', group: 'Serving' },
      { qty: 0.5, unit: 'cup', item: 'blue cheese dressing', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Pat the wings completely dry with paper towels. Season all over with salt, pepper, and garlic powder. Let sit at room temperature for 10 minutes.', timerMinutes: 10 },
      { order: 2, instruction: 'Heat oil in a deep fryer or large heavy pot to 375 degrees F. Fry wings in batches without crowding for 10-12 minutes until golden brown and cooked through (internal temp 165 degrees F).', timerMinutes: 12 },
      { order: 3, instruction: 'While the wings fry, whisk together the hot sauce, melted butter, white vinegar, and cayenne pepper in a large bowl.', timerMinutes: null },
      { order: 4, instruction: 'Drain the fried wings on a wire rack for 1 minute, then toss them in the buffalo sauce until fully coated.', timerMinutes: null },
      { order: 5, instruction: 'Pile the sauced wings on a platter and serve immediately with celery sticks and blue cheese dressing on the side.', timerMinutes: null },
    ],
    notes: 'For a baked version, arrange wings on a wire rack over a sheet pan and bake at 425 degrees F for 45 minutes, flipping halfway. The results are nearly as crispy with less mess. Adjust cayenne to control heat level.',
    communityRating: 4.8,
    communityRatingCount: 390,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Cobb Salad',
    description:
      'A composed salad of crisp greens topped with rows of grilled chicken, hard-boiled eggs, avocado, bacon, tomato, and crumbled blue cheese, all drizzled with a zesty red wine vinaigrette. A satisfying and colorful one-bowl meal.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/cobb-salad.jpg', caption: 'Beautifully arranged Cobb salad', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/cobb-salad-prep.jpg', caption: 'Ingredients prepped in rows', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 25,
    cookTime: 15,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Salads', 'Lunch', 'Dinner'],
    tags: ['high-protein', 'low-carb', 'gluten-free', 'meal-prep', 'under-30-min'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 420,
      protein: 35,
      carbs: 10,
      fat: 28,
      fiber: 5,
      sugar: 4,
      sodium: 720,
      iron: 2.5,
    },
    ingredients: [
      { qty: 2, unit: '', item: 'boneless skinless chicken breasts', group: 'Chicken' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Chicken' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Chicken' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Chicken' },
      { qty: 8, unit: 'cups', item: 'chopped romaine lettuce', group: 'Salad' },
      { qty: 4, unit: '', item: 'hard-boiled eggs, quartered', group: 'Salad' },
      { qty: 6, unit: 'slices', item: 'cooked bacon, crumbled', group: 'Salad' },
      { qty: 2, unit: '', item: 'ripe avocados, diced', group: 'Salad' },
      { qty: 1, unit: 'cup', item: 'cherry tomatoes, halved', group: 'Salad' },
      { qty: 0.5, unit: 'cup', item: 'crumbled blue cheese', group: 'Salad' },
      { qty: 2, unit: 'tbsp', item: 'chopped fresh chives', group: 'Salad' },
      { qty: 3, unit: 'tbsp', item: 'red wine vinegar', group: 'Vinaigrette' },
      { qty: 1, unit: 'tsp', item: 'Dijon mustard', group: 'Vinaigrette' },
      { qty: 0.25, unit: 'cup', item: 'extra virgin olive oil', group: 'Vinaigrette' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Vinaigrette' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Vinaigrette' },
    ],
    steps: [
      { order: 1, instruction: 'Season the chicken breasts with olive oil, salt, and pepper. Grill over medium-high heat for 6-7 minutes per side until the internal temperature reaches 165 degrees F. Let rest for 5 minutes, then slice crosswise.', timerMinutes: 14 },
      { order: 2, instruction: 'While the chicken cooks, make the vinaigrette: whisk together red wine vinegar, Dijon mustard, salt, and pepper. Slowly drizzle in the olive oil while whisking until emulsified.', timerMinutes: null },
      { order: 3, instruction: 'Arrange the chopped romaine on a large platter or individual plates.', timerMinutes: null },
      { order: 4, instruction: 'Arrange the sliced chicken, quartered eggs, crumbled bacon, diced avocado, halved tomatoes, and blue cheese in neat rows across the lettuce.', timerMinutes: null },
      { order: 5, instruction: 'Drizzle the vinaigrette over the salad, sprinkle with fresh chives, and serve immediately.', timerMinutes: null },
    ],
    notes: 'You can substitute ranch dressing for the vinaigrette if you prefer. Prep the eggs and bacon ahead of time to make assembly quick on busy weeknights.',
    communityRating: 4.4,
    communityRatingCount: 210,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Blueberry Pancakes',
    description:
      'Fluffy, golden-brown pancakes bursting with fresh blueberries and kissed with a hint of vanilla. Stack them high, drizzle with warm maple syrup, and start your morning the right way.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/blueberry-pancakes.jpg', caption: 'Stack of blueberry pancakes with maple syrup', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/blueberry-pancakes-prep.jpg', caption: 'Pancake batter with blueberries folded in', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Breakfast', 'Family Meals'],
    tags: ['under-30-min', 'family-friendly', 'vegetarian', 'brunch', 'budget-friendly'],
    ageGroups: ['toddler', 'kid', 'teen', 'adult'],
    audience: 'family',
    nutrition: {
      calories: 350,
      protein: 9,
      carbs: 52,
      fat: 12,
      fiber: 2,
      sugar: 18,
      sodium: 480,
      iron: 2.0,
    },
    ingredients: [
      { qty: 1.5, unit: 'cups', item: 'all-purpose flour', group: 'Dry' },
      { qty: 2, unit: 'tbsp', item: 'granulated sugar', group: 'Dry' },
      { qty: 2, unit: 'tsp', item: 'baking powder', group: 'Dry' },
      { qty: 0.5, unit: 'tsp', item: 'baking soda', group: 'Dry' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Dry' },
      { qty: 1.25, unit: 'cups', item: 'buttermilk', group: 'Wet' },
      { qty: 1, unit: '', item: 'large egg', group: 'Wet' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter, melted', group: 'Wet' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Wet' },
      { qty: 1, unit: 'cup', item: 'fresh blueberries', group: 'Mix-ins' },
      { qty: 0.5, unit: 'cup', item: 'maple syrup, for serving', group: 'Serving' },
      { qty: 2, unit: 'tbsp', item: 'butter, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'In a large bowl, whisk together the flour, sugar, baking powder, baking soda, and salt.', timerMinutes: null },
      { order: 2, instruction: 'In a separate bowl, whisk together the buttermilk, egg, melted butter, and vanilla. Pour the wet ingredients into the dry and stir until just combined. A few small lumps are fine. Gently fold in the blueberries.', timerMinutes: null },
      { order: 3, instruction: 'Heat a non-stick griddle or skillet over medium heat and lightly grease with butter. Pour about 1/3 cup of batter per pancake.', timerMinutes: null },
      { order: 4, instruction: 'Cook until bubbles form on the surface and the edges look set, about 2-3 minutes. Flip and cook the other side until golden brown, about 1-2 minutes more.', timerMinutes: 3 },
      { order: 5, instruction: 'Stack pancakes on plates, top with a pat of butter, and drizzle generously with warm maple syrup.', timerMinutes: null },
    ],
    notes: 'The key to fluffy pancakes is not overmixing the batter. A few lumps are perfectly fine. If you do not have buttermilk, add 1 tablespoon of white vinegar to 1.25 cups of milk and let it sit 5 minutes.',
    communityRating: 4.5,
    communityRatingCount: 340,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Apple Pie',
    description:
      'A golden, flaky double-crust pie filled with tender cinnamon-spiced apples and a hint of lemon. This quintessential American dessert fills the kitchen with the most intoxicating aroma and tastes even better with a scoop of vanilla ice cream.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/apple-pie.jpg', caption: 'Golden apple pie with lattice top', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/apple-pie-prep.jpg', caption: 'Sliced apples tossed in cinnamon and sugar', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 40,
    cookTime: 55,
    totalTime: 95,
    difficulty: 'hard',
    spiceLevel: 0,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Dessert', 'Baking'],
    tags: ['vegetarian', 'baking', 'holiday', 'make-ahead', 'celebration', 'comfort-food'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 380,
      protein: 4,
      carbs: 56,
      fat: 17,
      fiber: 3,
      sugar: 30,
      sodium: 260,
      iron: 1.2,
    },
    ingredients: [
      { qty: 2.5, unit: 'cups', item: 'all-purpose flour', group: 'Crust' },
      { qty: 1, unit: 'tbsp', item: 'granulated sugar', group: 'Crust' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Crust' },
      { qty: 1, unit: 'cup', item: 'cold unsalted butter, cubed', group: 'Crust' },
      { qty: 6, unit: 'tbsp', item: 'ice water', group: 'Crust' },
      { qty: 3, unit: 'lb', item: 'Granny Smith and Honeycrisp apples (mixed), peeled and sliced', group: 'Filling' },
      { qty: 0.75, unit: 'cup', item: 'granulated sugar', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'all-purpose flour', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Filling' },
      { qty: 1.5, unit: 'tsp', item: 'ground cinnamon', group: 'Filling' },
      { qty: 0.25, unit: 'tsp', item: 'ground nutmeg', group: 'Filling' },
      { qty: 1, unit: '', item: 'egg, beaten (for egg wash)', group: 'Topping' },
      { qty: 1, unit: 'tbsp', item: 'coarse sugar', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Make the crust: Pulse flour, sugar, and salt in a food processor. Add cold butter cubes and pulse until the mixture resembles coarse crumbs with pea-sized pieces. Drizzle in ice water and pulse until the dough just comes together. Divide in half, flatten into discs, wrap in plastic, and refrigerate for at least 1 hour.', timerMinutes: 60 },
      { order: 2, instruction: 'In a large bowl, toss the sliced apples with sugar, flour, lemon juice, cinnamon, and nutmeg until evenly coated.', timerMinutes: null },
      { order: 3, instruction: 'Preheat the oven to 425 degrees F. Roll out one disc of dough on a floured surface into a 12-inch circle. Fit it into a 9-inch pie plate, letting excess hang over the edges.', timerMinutes: null },
      { order: 4, instruction: 'Pile the apple filling into the crust, mounding it slightly higher in the center. Roll out the second disc and place it over the filling. Trim, fold, and crimp the edges. Cut 4-5 slits in the top for steam to escape.', timerMinutes: null },
      { order: 5, instruction: 'Brush the top crust with beaten egg and sprinkle with coarse sugar. Place the pie on a baking sheet to catch drips.', timerMinutes: null },
      { order: 6, instruction: 'Bake at 425 degrees F for 20 minutes, then reduce heat to 375 degrees F and bake for an additional 35 minutes, until the crust is deep golden and the juices are bubbling.', timerMinutes: 55 },
      { order: 7, instruction: 'Let the pie cool on a wire rack for at least 2 hours before slicing. This allows the filling to set.', timerMinutes: 120 },
    ],
    notes: 'For a lattice top, cut the second rolled-out dough into strips and weave them over the filling. A mix of tart and sweet apple varieties gives the best flavor and texture. The pie keeps at room temperature for 2 days.',
    communityRating: 4.7,
    communityRatingCount: 310,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Steak with Baked Potato',
    description:
      'A thick-cut, perfectly seared ribeye steak with a beautiful crust, paired with a fluffy baked potato loaded with butter, sour cream, and chives. The quintessential American steakhouse dinner, right at home.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/steak-baked-potato.jpg', caption: 'Seared ribeye with loaded baked potato', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/steak-baked-potato-prep.jpg', caption: 'Steak seasoned and resting at room temperature', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 40,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 0,
    cuisine: 'American',
    region: 'Americas',
    country: 'United States',
    categories: ['Dinner'],
    tags: ['high-protein', 'gluten-free', 'date-night', 'sunday-dinner', 'celebration'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 680,
      protein: 48,
      carbs: 42,
      fat: 36,
      fiber: 4,
      sugar: 2,
      sodium: 640,
      iron: 5.8,
    },
    ingredients: [
      { qty: 4, unit: '', item: 'ribeye steaks (10-12 oz each, 1 inch thick)', group: 'Steak' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Steak' },
      { qty: 2, unit: 'tsp', item: 'kosher salt', group: 'Steak' },
      { qty: 1, unit: 'tsp', item: 'coarsely ground black pepper', group: 'Steak' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter', group: 'Steak' },
      { qty: 4, unit: 'sprigs', item: 'fresh thyme', group: 'Steak' },
      { qty: 4, unit: 'cloves', item: 'garlic, smashed', group: 'Steak' },
      { qty: 4, unit: '', item: 'large russet potatoes', group: 'Baked Potato' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Baked Potato' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Baked Potato' },
      { qty: 4, unit: 'tbsp', item: 'butter', group: 'Potato Toppings' },
      { qty: 0.5, unit: 'cup', item: 'sour cream', group: 'Potato Toppings' },
      { qty: 0.25, unit: 'cup', item: 'chopped fresh chives', group: 'Potato Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 400 degrees F. Scrub the potatoes, prick all over with a fork, rub with olive oil and salt. Place directly on the oven rack and bake for 45-55 minutes until tender when pierced.', timerMinutes: 50 },
      { order: 2, instruction: 'About 20 minutes before the potatoes are done, remove steaks from the fridge. Pat very dry and season generously with kosher salt and pepper on all sides.', timerMinutes: null },
      { order: 3, instruction: 'Heat a large cast-iron skillet over high heat until smoking. Add vegetable oil, then carefully place the steaks in the pan. Sear without moving for 4 minutes until a dark crust forms.', timerMinutes: 4 },
      { order: 4, instruction: 'Flip the steaks. Add butter, thyme, and garlic to the pan. Tilt the pan and baste the steaks with the foaming butter for 3-4 minutes for medium-rare (130 degrees F internal).', timerMinutes: 4 },
      { order: 5, instruction: 'Transfer steaks to a cutting board and rest for 8-10 minutes. The temperature will rise another 5 degrees as it rests.', timerMinutes: 10 },
      { order: 6, instruction: 'Split the baked potatoes open and fluff the insides with a fork. Top each with a tablespoon of butter, a dollop of sour cream, and a sprinkle of chives. Serve alongside the rested steaks.', timerMinutes: null },
    ],
    notes: 'Let the steaks come to room temperature for 30 minutes before cooking for the most even sear. For a compound butter finish, mix softened butter with minced garlic and herbs, and place a round on each steak as it rests.',
    communityRating: 4.9,
    communityRatingCount: 450,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },

  // ==================== SOUTHERN US / CAJUN (5) ====================
  {
    title: 'BBQ Pulled Pork',
    description:
      'Smoky, melt-in-your-mouth pork shoulder slow-cooked until fork-tender and shredded, then drenched in a tangy-sweet barbecue sauce. Pile it high on soft buns and top with creamy coleslaw for the ultimate Southern sandwich.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bbq-pulled-pork.jpg', caption: 'Pulled pork sandwich with coleslaw', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bbq-pulled-pork-prep.jpg', caption: 'Seasoned pork shoulder before slow cooking', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 20,
    cookTime: 480,
    totalTime: 500,
    difficulty: 'easy',
    spiceLevel: 1,
    cuisine: 'Southern US',
    region: 'Americas',
    country: 'United States',
    categories: ['Dinner', 'Lunch', 'Family Meals'],
    tags: ['slow-cooker', 'batch-cooking', 'freezer-friendly', 'make-ahead', 'high-protein', 'comfort-food', 'game-day', 'family-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',
    nutrition: {
      calories: 520,
      protein: 38,
      carbs: 36,
      fat: 24,
      fiber: 1,
      sugar: 18,
      sodium: 780,
      iron: 3.0,
    },
    ingredients: [
      { qty: 4, unit: 'lb', item: 'bone-in pork shoulder (Boston butt)', group: 'Pork' },
      { qty: 2, unit: 'tbsp', item: 'brown sugar', group: 'Dry Rub' },
      { qty: 1, unit: 'tbsp', item: 'smoked paprika', group: 'Dry Rub' },
      { qty: 1, unit: 'tbsp', item: 'garlic powder', group: 'Dry Rub' },
      { qty: 1, unit: 'tsp', item: 'onion powder', group: 'Dry Rub' },
      { qty: 1, unit: 'tsp', item: 'cumin', group: 'Dry Rub' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Dry Rub' },
      { qty: 1, unit: 'tsp', item: 'black pepper', group: 'Dry Rub' },
      { qty: 0.5, unit: 'tsp', item: 'cayenne pepper', group: 'Dry Rub' },
      { qty: 0.5, unit: 'cup', item: 'apple cider vinegar', group: 'Braising Liquid' },
      { qty: 0.5, unit: 'cup', item: 'chicken broth', group: 'Braising Liquid' },
      { qty: 1.5, unit: 'cups', item: 'barbecue sauce', group: 'Sauce' },
      { qty: 8, unit: '', item: 'soft hamburger buns', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Combine all the dry rub ingredients in a small bowl. Pat the pork shoulder dry and rub the spice mixture all over, pressing it into the meat.', timerMinutes: null },
      { order: 2, instruction: 'Place the pork in a slow cooker. Pour the apple cider vinegar and chicken broth around the sides. Cover and cook on LOW for 8 hours until the meat is completely tender and shreds easily.', timerMinutes: 480 },
      { order: 3, instruction: 'Remove the pork from the slow cooker, discard the bone and any large fat pieces. Shred the meat with two forks.', timerMinutes: null },
      { order: 4, instruction: 'Skim the fat from the cooking liquid. Return the shredded pork to the slow cooker and add the barbecue sauce. Stir to combine and let it warm through on HIGH for 15 minutes.', timerMinutes: 15 },
      { order: 5, instruction: 'Toast the buns lightly and pile high with pulled pork. Serve with coleslaw on top or on the side.', timerMinutes: null },
    ],
    notes: 'This also works in a Dutch oven at 300 degrees F for 4-5 hours. The pulled pork freezes beautifully for up to 3 months. For Carolina-style, skip the barbecue sauce and use a vinegar-based mop sauce instead.',
    communityRating: 4.8,
    communityRatingCount: 380,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Mac and Cheese',
    description:
      'Ultra-creamy, baked macaroni and cheese made with a trio of cheeses and topped with a golden, buttery breadcrumb crust. This Southern comfort classic is pure cheesy indulgence in every single bite.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mac-and-cheese.jpg', caption: 'Baked mac and cheese with golden breadcrumb topping', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mac-and-cheese-prep.jpg', caption: 'Cheese sauce being poured over elbow macaroni', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 35,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'Southern US',
    region: 'Americas',
    country: 'United States',
    categories: ['Dinner', 'Sides', 'Family Meals'],
    tags: ['vegetarian', 'baking', 'comfort-food', 'family-friendly', 'weeknight-dinner', 'budget-friendly'],
    ageGroups: ['toddler', 'kid', 'teen', 'adult'],
    audience: 'family',
    nutrition: {
      calories: 520,
      protein: 22,
      carbs: 48,
      fat: 28,
      fiber: 2,
      sugar: 4,
      sodium: 720,
      iron: 1.8,
    },
    ingredients: [
      { qty: 1, unit: 'lb', item: 'elbow macaroni', group: 'Pasta' },
      { qty: 4, unit: 'tbsp', item: 'unsalted butter', group: 'Cheese Sauce' },
      { qty: 0.25, unit: 'cup', item: 'all-purpose flour', group: 'Cheese Sauce' },
      { qty: 3, unit: 'cups', item: 'whole milk', group: 'Cheese Sauce' },
      { qty: 2, unit: 'cups', item: 'shredded sharp cheddar cheese', group: 'Cheese Sauce' },
      { qty: 1, unit: 'cup', item: 'shredded Gruyere cheese', group: 'Cheese Sauce' },
      { qty: 0.5, unit: 'cup', item: 'shredded Monterey Jack cheese', group: 'Cheese Sauce' },
      { qty: 1, unit: 'tsp', item: 'Dijon mustard', group: 'Cheese Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'smoked paprika', group: 'Cheese Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Cheese Sauce' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Cheese Sauce' },
      { qty: 0.75, unit: 'cup', item: 'panko breadcrumbs', group: 'Topping' },
      { qty: 2, unit: 'tbsp', item: 'melted butter', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 375 degrees F. Cook the macaroni in salted boiling water until just al dente (1 minute less than package directions). Drain and set aside.', timerMinutes: 8 },
      { order: 2, instruction: 'In a large saucepan, melt butter over medium heat. Whisk in flour and cook for 1 minute. Gradually whisk in milk and cook, stirring constantly, until thickened, about 5 minutes.', timerMinutes: 6 },
      { order: 3, instruction: 'Remove from heat. Stir in all three cheeses, mustard, paprika, salt, and pepper until completely melted and smooth. Fold in the drained macaroni.', timerMinutes: null },
      { order: 4, instruction: 'Pour into a greased 9x13 inch baking dish. Toss the panko with melted butter and sprinkle evenly over the top.', timerMinutes: null },
      { order: 5, instruction: 'Bake for 25 minutes until the sauce is bubbling around the edges and the breadcrumb topping is golden and crispy.', timerMinutes: 25 },
      { order: 6, instruction: 'Let rest for 5 minutes before serving. The sauce will thicken slightly as it cools.', timerMinutes: 5 },
    ],
    notes: 'For an extra-creamy version, add 4 oz cream cheese to the sauce. Undercook the pasta slightly since it will continue cooking in the oven. This reheats well with a splash of milk.',
    communityRating: 4.7,
    communityRatingCount: 410,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Shrimp and Grits',
    description:
      'Plump, juicy shrimp sauteed with andouille sausage, peppers, and garlic in a savory sauce, served over creamy, stone-ground cheddar grits. This beloved Lowcountry classic brings the soul of Charleston to your table.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/shrimp-and-grits.jpg', caption: 'Shrimp and sausage over creamy grits', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/shrimp-and-grits-prep.jpg', caption: 'Seasoned shrimp and sliced andouille', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'medium',
    spiceLevel: 2,
    cuisine: 'Southern US',
    region: 'Americas',
    country: 'United States',
    categories: ['Dinner', 'Breakfast'],
    tags: ['one-pan', 'high-protein', 'comfort-food', 'date-night', 'brunch', 'weeknight-dinner'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 490,
      protein: 32,
      carbs: 35,
      fat: 24,
      fiber: 2,
      sugar: 3,
      sodium: 920,
      iron: 3.5,
    },
    ingredients: [
      { qty: 1, unit: 'cup', item: 'stone-ground grits', group: 'Grits' },
      { qty: 3, unit: 'cups', item: 'water', group: 'Grits' },
      { qty: 1, unit: 'cup', item: 'whole milk', group: 'Grits' },
      { qty: 1, unit: 'cup', item: 'shredded sharp cheddar cheese', group: 'Grits' },
      { qty: 2, unit: 'tbsp', item: 'unsalted butter', group: 'Grits' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Grits' },
      { qty: 1.5, unit: 'lb', item: 'large shrimp, peeled and deveined', group: 'Shrimp' },
      { qty: 6, unit: 'oz', item: 'andouille sausage, sliced', group: 'Shrimp' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Shrimp' },
      { qty: 1, unit: '', item: 'green bell pepper, diced', group: 'Shrimp' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Shrimp' },
      { qty: 0.5, unit: 'cup', item: 'chicken broth', group: 'Shrimp' },
      { qty: 2, unit: 'tbsp', item: 'fresh lemon juice', group: 'Shrimp' },
      { qty: 1, unit: 'tsp', item: 'Cajun seasoning', group: 'Shrimp' },
      { qty: 2, unit: 'tbsp', item: 'sliced green onions', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Bring water and milk to a boil in a medium saucepan. Slowly whisk in the grits. Reduce heat to low, cover, and cook, stirring frequently, for 20-25 minutes until thick and creamy.', timerMinutes: 25 },
      { order: 2, instruction: 'While the grits cook, heat olive oil in a large skillet over medium-high heat. Cook the andouille slices until browned, about 3 minutes. Remove and set aside.', timerMinutes: 3 },
      { order: 3, instruction: 'In the same skillet, add the bell pepper and cook for 2 minutes. Add garlic and cook for 30 seconds. Season the shrimp with Cajun seasoning and add them to the pan. Cook for 2-3 minutes per side until pink and opaque.', timerMinutes: 5 },
      { order: 4, instruction: 'Return the andouille to the skillet. Add chicken broth and lemon juice. Simmer for 2 minutes, scraping up any browned bits.', timerMinutes: 2 },
      { order: 5, instruction: 'Stir the cheddar, butter, and salt into the finished grits until melted and smooth.', timerMinutes: null },
      { order: 6, instruction: 'Spoon the grits into bowls and top with the shrimp, sausage, and pan sauce. Garnish with sliced green onions.', timerMinutes: null },
    ],
    notes: 'Stone-ground grits have the best texture and flavor. If using quick grits, adjust cooking time per the package. For a smokier dish, use bacon fat instead of olive oil and crumble crispy bacon on top.',
    communityRating: 4.6,
    communityRatingCount: 240,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Jambalaya',
    description:
      'A bold, one-pot Creole rice dish loaded with chicken, andouille sausage, shrimp, and the holy trinity of onion, celery, and bell pepper. This New Orleans classic packs layers of spice and soul into every forkful.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jambalaya.jpg', caption: 'Steaming pot of Creole jambalaya', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jambalaya-prep.jpg', caption: 'Holy trinity vegetables diced and ready', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 40,
    totalTime: 60,
    difficulty: 'medium',
    spiceLevel: 3,
    cuisine: 'Cajun/Creole',
    region: 'Americas',
    country: 'United States',
    categories: ['Dinner', 'Soups & Stews'],
    tags: ['one-pot', 'high-protein', 'batch-cooking', 'freezer-friendly', 'comfort-food', 'weeknight-dinner'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 510,
      protein: 36,
      carbs: 44,
      fat: 20,
      fiber: 3,
      sugar: 5,
      sodium: 980,
      iron: 4.0,
    },
    ingredients: [
      { qty: 1, unit: 'lb', item: 'boneless skinless chicken thighs, cubed', group: 'Proteins' },
      { qty: 12, unit: 'oz', item: 'andouille sausage, sliced into half-moons', group: 'Proteins' },
      { qty: 0.75, unit: 'lb', item: 'large shrimp, peeled and deveined', group: 'Proteins' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Base' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Base' },
      { qty: 2, unit: 'stalks', item: 'celery, diced', group: 'Base' },
      { qty: 1, unit: '', item: 'green bell pepper, diced', group: 'Base' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Base' },
      { qty: 1, unit: 'can (14.5 oz)', item: 'diced tomatoes', group: 'Sauce' },
      { qty: 2.5, unit: 'cups', item: 'chicken broth', group: 'Sauce' },
      { qty: 1.5, unit: 'cups', item: 'long-grain white rice', group: 'Rice' },
      { qty: 2, unit: 'tsp', item: 'Cajun seasoning', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Seasonings' },
      { qty: 0.5, unit: 'tsp', item: 'dried thyme', group: 'Seasonings' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Seasonings' },
      { qty: 0.25, unit: 'tsp', item: 'cayenne pepper', group: 'Seasonings' },
      { qty: 3, unit: 'tbsp', item: 'chopped fresh parsley', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Heat oil in a large Dutch oven over medium-high heat. Season the chicken with half of the Cajun seasoning and sear until browned, about 4 minutes. Remove and set aside.', timerMinutes: 4 },
      { order: 2, instruction: 'In the same pot, brown the andouille sausage for 3 minutes. Remove and add to the chicken.', timerMinutes: 3 },
      { order: 3, instruction: 'Add onion, celery, and bell pepper to the pot. Cook for 5 minutes until softened. Add garlic and cook for 1 minute.', timerMinutes: 6 },
      { order: 4, instruction: 'Add the diced tomatoes, chicken broth, rice, remaining Cajun seasoning, paprika, thyme, bay leaves, and cayenne. Stir well and bring to a boil.', timerMinutes: null },
      { order: 5, instruction: 'Return the chicken and sausage to the pot. Reduce heat to low, cover tightly, and simmer for 20 minutes until the rice is tender and the liquid is absorbed.', timerMinutes: 20 },
      { order: 6, instruction: 'Place the shrimp on top of the rice, cover, and cook for 5 more minutes until the shrimp are pink and curled.', timerMinutes: 5 },
      { order: 7, instruction: 'Remove the bay leaves. Fluff with a fork, sprinkle with fresh parsley, and serve directly from the pot.', timerMinutes: null },
    ],
    notes: 'Do not lift the lid during the rice cooking phase. The trapped steam is what cooks the rice evenly. If you prefer Cajun-style jambalaya, omit the tomatoes and increase the broth by half a cup.',
    communityRating: 4.7,
    communityRatingCount: 360,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Cornbread',
    description:
      'Golden, slightly sweet cornbread with a crispy, buttery edge baked in a searing-hot cast-iron skillet. Tender in the middle and crumbly at the crust, this is the perfect companion to chili, greens, or just a drizzle of honey.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/cornbread.jpg', caption: 'Skillet cornbread sliced into wedges', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/cornbread-prep.jpg', caption: 'Cornmeal batter being poured into hot skillet', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'Southern US',
    region: 'Americas',
    country: 'United States',
    categories: ['Sides', 'Baking'],
    tags: ['vegetarian', 'baking', 'under-30-min', 'family-friendly', 'comfort-food', 'budget-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 220,
      protein: 5,
      carbs: 30,
      fat: 9,
      fiber: 1,
      sugar: 8,
      sodium: 340,
      iron: 1.2,
    },
    ingredients: [
      { qty: 1, unit: 'cup', item: 'yellow cornmeal', group: 'Dry' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour', group: 'Dry' },
      { qty: 0.33, unit: 'cup', item: 'granulated sugar', group: 'Dry' },
      { qty: 1, unit: 'tbsp', item: 'baking powder', group: 'Dry' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Dry' },
      { qty: 1, unit: 'cup', item: 'buttermilk', group: 'Wet' },
      { qty: 2, unit: '', item: 'large eggs', group: 'Wet' },
      { qty: 0.25, unit: 'cup', item: 'unsalted butter, melted', group: 'Wet' },
      { qty: 2, unit: 'tbsp', item: 'unsalted butter (for the skillet)', group: 'Skillet' },
      { qty: 2, unit: 'tbsp', item: 'honey, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Place a 10-inch cast-iron skillet with the 2 tablespoons of butter in the oven while it preheats.', timerMinutes: null },
      { order: 2, instruction: 'In a large bowl, whisk together cornmeal, flour, sugar, baking powder, and salt.', timerMinutes: null },
      { order: 3, instruction: 'In a separate bowl, whisk together buttermilk, eggs, and melted butter. Pour into the dry ingredients and stir until just combined.', timerMinutes: null },
      { order: 4, instruction: 'Carefully remove the hot skillet from the oven. Swirl the melted butter to coat the bottom and sides. Pour the batter into the sizzling skillet.', timerMinutes: null },
      { order: 5, instruction: 'Bake for 20-25 minutes until the top is golden and a toothpick inserted in the center comes out clean.', timerMinutes: 22 },
      { order: 6, instruction: 'Let cool in the skillet for 5 minutes, then slice into wedges. Serve warm with butter and a drizzle of honey.', timerMinutes: 5 },
    ],
    notes: 'The hot skillet is the secret to that coveted crispy bottom crust. For savory cornbread, reduce sugar to 1 tablespoon and fold in diced jalapenos and shredded cheddar cheese.',
    communityRating: 4.5,
    communityRatingCount: 290,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },

  // ==================== MEXICAN (7) ====================
  {
    title: 'Chicken Tacos al Pastor',
    description:
      'Juicy chicken thighs marinated in a smoky, tangy adobo-pineapple sauce, seared until charred, and piled into warm corn tortillas with fresh pineapple, cilantro, and onion. All the magic of the trompo, simplified for your kitchen.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-tacos-al-pastor.jpg', caption: 'Tacos al pastor with pineapple and cilantro', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-tacos-al-pastor-prep.jpg', caption: 'Chicken marinating in adobo-pineapple sauce', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 25,
    cookTime: 15,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 2,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Dinner', 'Lunch'],
    tags: ['high-protein', 'dairy-free', 'under-30-min', 'weeknight-dinner', 'family-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 420,
      protein: 30,
      carbs: 38,
      fat: 16,
      fiber: 4,
      sugar: 10,
      sodium: 650,
      iron: 2.8,
    },
    ingredients: [
      { qty: 1.5, unit: 'lb', item: 'boneless skinless chicken thighs', group: 'Chicken' },
      { qty: 3, unit: '', item: 'dried guajillo chiles, stems and seeds removed', group: 'Marinade' },
      { qty: 2, unit: '', item: 'chipotle peppers in adobo sauce', group: 'Marinade' },
      { qty: 0.5, unit: 'cup', item: 'pineapple juice', group: 'Marinade' },
      { qty: 3, unit: 'cloves', item: 'garlic', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'white vinegar', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Marinade' },
      { qty: 12, unit: '', item: 'small corn tortillas', group: 'Serving' },
      { qty: 1, unit: 'cup', item: 'diced fresh pineapple', group: 'Toppings' },
      { qty: 0.5, unit: 'cup', item: 'diced white onion', group: 'Toppings' },
      { qty: 0.5, unit: 'cup', item: 'chopped fresh cilantro', group: 'Toppings' },
      { qty: 2, unit: '', item: 'limes, quartered', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Toast the guajillo chiles in a dry skillet for 30 seconds per side, then soak in hot water for 10 minutes until softened. Drain.', timerMinutes: 10 },
      { order: 2, instruction: 'Blend the rehydrated chiles, chipotles, pineapple juice, garlic, cumin, oregano, vinegar, and salt in a blender until smooth. Pour over the chicken thighs and marinate for at least 30 minutes (or up to overnight in the fridge).', timerMinutes: 30 },
      { order: 3, instruction: 'Heat a large cast-iron skillet or grill pan over high heat. Cook the chicken for 5-6 minutes per side until charred and cooked through (165 degrees F internal). Let rest 5 minutes, then dice into small pieces.', timerMinutes: 12 },
      { order: 4, instruction: 'In the same hot pan, quickly sear the diced pineapple pieces for 1-2 minutes until caramelized. Warm the tortillas on the skillet for about 20 seconds per side.', timerMinutes: null },
      { order: 5, instruction: 'Assemble the tacos by layering diced chicken onto doubled-up tortillas. Top with seared pineapple, diced onion, fresh cilantro, and a generous squeeze of lime.', timerMinutes: null },
    ],
    notes: 'For even deeper flavor, marinate the chicken overnight. If you cannot find guajillo chiles, substitute 2 tablespoons of ancho chile powder. Serve with a smoky salsa verde on the side.',
    communityRating: 4.6,
    communityRatingCount: 320,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Carnitas',
    description:
      'Succulent, slow-braised pork shoulder cooked in citrus juice, garlic, and warm spices until falling-apart tender, then crisped under the broiler for irresistible caramelized edges. The crown jewel of Mexican pork dishes.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/carnitas.jpg', caption: 'Crispy carnitas served with tortillas and lime', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/carnitas-prep.jpg', caption: 'Pork shoulder seasoned with citrus and spices', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 15,
    cookTime: 210,
    totalTime: 225,
    difficulty: 'easy',
    spiceLevel: 1,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Dinner', 'Family Meals'],
    tags: ['slow-cooker', 'batch-cooking', 'freezer-friendly', 'make-ahead', 'high-protein', 'gluten-free', 'dairy-free'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',
    nutrition: {
      calories: 440,
      protein: 36,
      carbs: 4,
      fat: 30,
      fiber: 0,
      sugar: 2,
      sodium: 580,
      iron: 3.2,
    },
    ingredients: [
      { qty: 4, unit: 'lb', item: 'boneless pork shoulder, cut into 3-inch chunks', group: 'Pork' },
      { qty: 2, unit: 'tsp', item: 'salt', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'black pepper', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Seasonings' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Seasonings' },
      { qty: 1, unit: '', item: 'orange, juiced', group: 'Braising Liquid' },
      { qty: 2, unit: '', item: 'limes, juiced', group: 'Braising Liquid' },
      { qty: 6, unit: 'cloves', item: 'garlic, smashed', group: 'Braising Liquid' },
      { qty: 1, unit: '', item: 'white onion, quartered', group: 'Braising Liquid' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Braising Liquid' },
      { qty: 0.5, unit: 'cup', item: 'water', group: 'Braising Liquid' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 300 degrees F. Season the pork chunks all over with salt, pepper, cumin, oregano, and cinnamon.', timerMinutes: null },
      { order: 2, instruction: 'Place the pork in a Dutch oven. Add orange juice, lime juice, garlic, onion, bay leaves, and water. The liquid should come about one-third of the way up the meat.', timerMinutes: null },
      { order: 3, instruction: 'Cover tightly and braise in the oven for 3 to 3.5 hours, until the pork is fork-tender and falling apart.', timerMinutes: 210 },
      { order: 4, instruction: 'Remove the pork from the liquid and shred with two forks, discarding bay leaves and onion. Skim the fat from the braising liquid.', timerMinutes: null },
      { order: 5, instruction: 'Spread the shredded pork on a sheet pan. Spoon a few tablespoons of the braising liquid over the meat. Broil on high for 5-7 minutes, watching carefully, until the edges are deeply crispy and caramelized.', timerMinutes: 6 },
      { order: 6, instruction: 'Serve in tacos, burritos, or over rice with salsa, guacamole, and lime wedges.', timerMinutes: null },
    ],
    notes: 'The broiling step is what sets great carnitas apart. Watch closely to avoid burning. Save the braising liquid to drizzle over leftovers. Carnitas freeze exceptionally well for up to 3 months.',
    communityRating: 4.8,
    communityRatingCount: 350,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Enchiladas Rojas',
    description:
      'Soft corn tortillas rolled around shredded chicken and cheese, blanketed in a vibrant, earthy red chile sauce, and baked until bubbly. Topped with crema, queso fresco, and onion, these are enchiladas as they are meant to be.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/enchiladas-rojas.jpg', caption: 'Baked enchiladas topped with crema and queso fresco', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/enchiladas-rojas-prep.jpg', caption: 'Red chile sauce being blended', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 25,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 2,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Dinner'],
    tags: ['baking', 'comfort-food', 'batch-cooking', 'weeknight-dinner', 'high-protein'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 480,
      protein: 28,
      carbs: 40,
      fat: 22,
      fiber: 5,
      sugar: 4,
      sodium: 750,
      iron: 3.0,
    },
    ingredients: [
      { qty: 5, unit: '', item: 'dried guajillo chiles, stems and seeds removed', group: 'Red Sauce' },
      { qty: 2, unit: '', item: 'dried ancho chiles, stems and seeds removed', group: 'Red Sauce' },
      { qty: 2, unit: 'cups', item: 'hot water (for soaking)', group: 'Red Sauce' },
      { qty: 3, unit: 'cloves', item: 'garlic', group: 'Red Sauce' },
      { qty: 0.5, unit: '', item: 'white onion, roughly chopped', group: 'Red Sauce' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Red Sauce' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Red Sauce' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Red Sauce' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Red Sauce' },
      { qty: 3, unit: 'cups', item: 'shredded cooked chicken', group: 'Filling' },
      { qty: 1.5, unit: 'cups', item: 'shredded Oaxaca or Monterey Jack cheese', group: 'Filling' },
      { qty: 12, unit: '', item: 'corn tortillas', group: 'Assembly' },
      { qty: 0.25, unit: 'cup', item: 'vegetable oil (for softening tortillas)', group: 'Assembly' },
      { qty: 0.5, unit: 'cup', item: 'crumbled queso fresco', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'Mexican crema or sour cream', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'sliced white onion rings', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Toast the guajillo and ancho chiles in a dry skillet for 30 seconds per side until fragrant. Soak in hot water for 15 minutes until softened.', timerMinutes: 15 },
      { order: 2, instruction: 'Drain the chiles (reserve 1 cup soaking liquid). Blend with garlic, onion, cumin, oregano, salt, and reserved soaking liquid until very smooth.', timerMinutes: null },
      { order: 3, instruction: 'Heat 1 tablespoon oil in a saucepan over medium heat. Strain the sauce through a fine mesh sieve into the pan, pressing with a spoon. Simmer for 10 minutes until thickened slightly.', timerMinutes: 10 },
      { order: 4, instruction: 'Preheat oven to 375 degrees F. Heat a thin layer of oil in a skillet and quickly dip each tortilla for 5 seconds per side to soften. Drain on paper towels.', timerMinutes: null },
      { order: 5, instruction: 'Spread a thin layer of sauce on the bottom of a 9x13 baking dish. Fill each softened tortilla with shredded chicken and a sprinkle of cheese, roll tightly, and place seam-side down in the dish.', timerMinutes: null },
      { order: 6, instruction: 'Pour the remaining sauce over the rolled enchiladas. Top with the rest of the shredded cheese. Bake for 20-25 minutes until bubbly.', timerMinutes: 22 },
      { order: 7, instruction: 'Remove from the oven and top with crumbled queso fresco, a drizzle of crema, and sliced onion rings. Serve immediately.', timerMinutes: null },
    ],
    notes: 'The key to great enchiladas is properly softening the tortillas in oil before rolling. This prevents cracking and gives them better texture. Use rotisserie chicken for a quick weeknight shortcut.',
    communityRating: 4.5,
    communityRatingCount: 270,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Elote (Mexican Street Corn)',
    description:
      'Charred ears of corn slathered with creamy mayo, tangy crema, and crumbled cotija cheese, then dusted with chili powder and a bright squeeze of lime. This beloved Mexican street food is summer in every smoky, messy, glorious bite.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/elote.jpg', caption: 'Grilled elote with cotija and chili powder', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/elote-prep.jpg', caption: 'Corn on the grill getting charred', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 12,
    totalTime: 22,
    difficulty: 'easy',
    spiceLevel: 2,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Sides', 'Snacks', 'Appetizers'],
    tags: ['grilling', 'vegetarian', 'under-30-min', 'gluten-free', 'party', 'picnic'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 240,
      protein: 8,
      carbs: 22,
      fat: 15,
      fiber: 3,
      sugar: 6,
      sodium: 380,
      iron: 0.8,
    },
    ingredients: [
      { qty: 4, unit: '', item: 'ears of corn, husked', group: 'Corn' },
      { qty: 0.25, unit: 'cup', item: 'mayonnaise', group: 'Sauce' },
      { qty: 0.25, unit: 'cup', item: 'Mexican crema or sour cream', group: 'Sauce' },
      { qty: 0.5, unit: 'cup', item: 'crumbled cotija cheese', group: 'Toppings' },
      { qty: 1, unit: 'tsp', item: 'chili powder (or Tajin seasoning)', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'chopped fresh cilantro', group: 'Toppings' },
      { qty: 2, unit: '', item: 'limes, halved', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat a grill to medium-high heat (or use a grill pan on the stove). Lightly oil the grates.', timerMinutes: null },
      { order: 2, instruction: 'Grill the corn, turning every 3 minutes, until charred in spots all around, about 10-12 minutes total.', timerMinutes: 12 },
      { order: 3, instruction: 'In a small bowl, mix the mayonnaise and crema together until smooth.', timerMinutes: null },
      { order: 4, instruction: 'As soon as the corn comes off the grill, brush or spread the mayo-crema mixture generously all over each ear.', timerMinutes: null },
      { order: 5, instruction: 'Roll the corn in crumbled cotija cheese, pressing to adhere. Sprinkle with chili powder and cilantro, and finish with a big squeeze of fresh lime juice. Serve immediately.', timerMinutes: null },
    ],
    notes: 'For esquites (off-the-cob version), cut the charred kernels off and toss everything together in a bowl. This is easier to eat and works great as a side dish or a taco topping.',
    communityRating: 4.4,
    communityRatingCount: 250,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Pozole Rojo',
    description:
      'A rich, deeply flavorful Mexican soup of tender hominy and succulent pork simmered in a fragrant dried chile broth. Served with a dazzling array of fresh garnishes, this celebratory dish is tradition in a bowl.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pozole-rojo.jpg', caption: 'Bowl of red pozole with fresh garnishes', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pozole-rojo-prep.jpg', caption: 'Dried chiles soaking in hot water', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 25,
    cookTime: 120,
    totalTime: 145,
    difficulty: 'medium',
    spiceLevel: 2,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Soups & Stews', 'Dinner'],
    tags: ['one-pot', 'gluten-free', 'dairy-free', 'high-protein', 'batch-cooking', 'comfort-food', 'holiday', 'celebration'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 420,
      protein: 30,
      carbs: 34,
      fat: 18,
      fiber: 6,
      sugar: 3,
      sodium: 850,
      iron: 3.8,
    },
    ingredients: [
      { qty: 2, unit: 'lb', item: 'bone-in pork shoulder, cut into large chunks', group: 'Pork' },
      { qty: 8, unit: 'cups', item: 'water', group: 'Pork' },
      { qty: 1, unit: '', item: 'white onion, halved', group: 'Pork' },
      { qty: 4, unit: 'cloves', item: 'garlic', group: 'Pork' },
      { qty: 2, unit: 'tsp', item: 'salt', group: 'Pork' },
      { qty: 4, unit: '', item: 'dried guajillo chiles, stems and seeds removed', group: 'Chile Sauce' },
      { qty: 2, unit: '', item: 'dried ancho chiles, stems and seeds removed', group: 'Chile Sauce' },
      { qty: 1, unit: 'cup', item: 'hot water (for soaking)', group: 'Chile Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'ground cumin', group: 'Chile Sauce' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Chile Sauce' },
      { qty: 2, unit: 'cans (29 oz each)', item: 'white hominy, drained and rinsed', group: 'Hominy' },
      { qty: 2, unit: 'cups', item: 'shredded green cabbage', group: 'Garnishes' },
      { qty: 1, unit: '', item: 'avocado, sliced', group: 'Garnishes' },
      { qty: 6, unit: '', item: 'radishes, thinly sliced', group: 'Garnishes' },
      { qty: 0.5, unit: 'cup', item: 'chopped fresh cilantro', group: 'Garnishes' },
      { qty: 3, unit: '', item: 'limes, quartered', group: 'Garnishes' },
      { qty: 8, unit: '', item: 'tostadas', group: 'Garnishes' },
    ],
    steps: [
      { order: 1, instruction: 'Place the pork, water, halved onion, garlic, and salt in a large pot. Bring to a boil, skimming any foam. Reduce to a simmer and cook, partially covered, for 1.5 to 2 hours until the pork is very tender.', timerMinutes: 105 },
      { order: 2, instruction: 'While the pork simmers, toast the guajillo and ancho chiles in a dry skillet for 30 seconds per side. Soak in hot water for 15 minutes. Blend the soaked chiles with their soaking liquid, cumin, and oregano until smooth. Strain through a sieve.', timerMinutes: null },
      { order: 3, instruction: 'Remove the pork from the broth. Shred the meat, discarding bones and excess fat. Strain the broth if desired.', timerMinutes: null },
      { order: 4, instruction: 'Return the broth to a simmer. Add the chile sauce and drained hominy. Cook for 20 minutes to meld the flavors.', timerMinutes: 20 },
      { order: 5, instruction: 'Return the shredded pork to the pot. Taste and adjust salt. Simmer for 5 more minutes.', timerMinutes: 5 },
      { order: 6, instruction: 'Ladle into large bowls and set out the garnishes: shredded cabbage, avocado, radishes, cilantro, limes, and tostadas. Let everyone customize their bowl.', timerMinutes: null },
    ],
    notes: 'Pozole is traditionally served on special occasions and tastes even better the next day. The garnishes are essential to the dish, not optional. For a quicker version, use a pressure cooker and reduce the pork cooking time to 45 minutes.',
    communityRating: 4.7,
    communityRatingCount: 180,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Churros',
    description:
      'Golden, ridged sticks of fried dough coated in cinnamon sugar and served with a rich, velvety chocolate dipping sauce. These crispy-on-the-outside, soft-on-the-inside Mexican treats are pure fried perfection.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/churros.jpg', caption: 'Cinnamon sugar churros with chocolate sauce', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/churros-prep.jpg', caption: 'Piping churro dough into hot oil', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 20,
    totalTime: 35,
    difficulty: 'medium',
    spiceLevel: 0,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Dessert', 'Snacks'],
    tags: ['vegetarian', 'party', 'family-friendly', 'comfort-food'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 320,
      protein: 4,
      carbs: 42,
      fat: 16,
      fiber: 1,
      sugar: 20,
      sodium: 210,
      iron: 1.5,
    },
    ingredients: [
      { qty: 1, unit: 'cup', item: 'water', group: 'Dough' },
      { qty: 0.5, unit: 'cup', item: 'unsalted butter', group: 'Dough' },
      { qty: 2, unit: 'tbsp', item: 'granulated sugar', group: 'Dough' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour', group: 'Dough' },
      { qty: 2, unit: '', item: 'large eggs', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Dough' },
      { qty: 4, unit: 'cups', item: 'vegetable oil, for frying', group: 'Frying' },
      { qty: 0.5, unit: 'cup', item: 'granulated sugar', group: 'Cinnamon Sugar' },
      { qty: 1.5, unit: 'tsp', item: 'ground cinnamon', group: 'Cinnamon Sugar' },
      { qty: 4, unit: 'oz', item: 'semisweet chocolate, chopped', group: 'Chocolate Sauce' },
      { qty: 0.5, unit: 'cup', item: 'heavy cream', group: 'Chocolate Sauce' },
      { qty: 1, unit: 'tbsp', item: 'unsalted butter', group: 'Chocolate Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'In a saucepan, bring water, butter, sugar, and salt to a boil. Remove from heat and stir in the flour all at once with a wooden spoon until a smooth dough forms and pulls away from the sides of the pan.', timerMinutes: null },
      { order: 2, instruction: 'Let the dough cool for 2 minutes, then beat in the eggs one at a time, followed by the vanilla, until smooth and glossy. Transfer the dough to a piping bag fitted with a large open-star tip.', timerMinutes: null },
      { order: 3, instruction: 'Heat oil in a heavy pot or deep fryer to 375 degrees F. Pipe 6-inch strips of dough directly into the hot oil, cutting with scissors. Fry in batches for 2-3 minutes per side until deep golden brown.', timerMinutes: 5 },
      { order: 4, instruction: 'Mix the sugar and cinnamon on a shallow plate. Remove the churros with a slotted spoon, drain briefly on paper towels, and roll immediately in the cinnamon sugar while still hot.', timerMinutes: null },
      { order: 5, instruction: 'For the chocolate sauce, heat the cream until steaming, pour over the chopped chocolate and butter, and stir until smooth and glossy.', timerMinutes: null },
      { order: 6, instruction: 'Serve the warm churros with the chocolate dipping sauce on the side.', timerMinutes: null },
    ],
    notes: 'The dough can be piped onto parchment paper strips and frozen, then fried directly from frozen (add 1-2 minutes to frying time). A star-shaped piping tip is essential for the classic ridged texture.',
    communityRating: 4.6,
    communityRatingCount: 300,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Black Bean Soup',
    description:
      'A hearty, smoky soup made with tender black beans slow-simmered with cumin, chipotle, and garlic, finished with a squeeze of lime and fresh garnishes. Deeply satisfying, naturally vegan, and packed with plant-based protein.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/black-bean-soup.jpg', caption: 'Thick black bean soup topped with avocado and cilantro', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/black-bean-soup-prep.jpg', caption: 'Beans and aromatics ready for the pot', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 45,
    totalTime: 60,
    difficulty: 'easy',
    spiceLevel: 2,
    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',
    categories: ['Soups & Stews', 'Dinner', 'Lunch'],
    tags: ['one-pot', 'vegan', 'gluten-free', 'dairy-free', 'high-fiber', 'high-protein', 'budget-friendly', 'batch-cooking', 'freezer-friendly', 'meal-prep'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 280,
      protein: 16,
      carbs: 44,
      fat: 5,
      fiber: 14,
      sugar: 4,
      sodium: 620,
      iron: 4.2,
    },
    ingredients: [
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Base' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Base' },
      { qty: 1, unit: '', item: 'green bell pepper, diced', group: 'Base' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Base' },
      { qty: 2, unit: 'tsp', item: 'ground cumin', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Seasonings' },
      { qty: 1, unit: '', item: 'chipotle pepper in adobo, minced', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Seasonings' },
      { qty: 3, unit: 'cans (15 oz each)', item: 'black beans, drained and rinsed', group: 'Beans' },
      { qty: 4, unit: 'cups', item: 'vegetable broth', group: 'Liquid' },
      { qty: 1, unit: 'can (14.5 oz)', item: 'diced tomatoes', group: 'Liquid' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Seasonings' },
      { qty: 2, unit: '', item: 'limes, juiced', group: 'Finish' },
      { qty: 1, unit: '', item: 'avocado, diced', group: 'Garnish' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro, chopped', group: 'Garnish' },
      { qty: 0.25, unit: 'cup', item: 'sour cream or Mexican crema (optional)', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil in a large pot over medium heat. Add onion and bell pepper and cook for 5 minutes until softened.', timerMinutes: 5 },
      { order: 2, instruction: 'Add garlic, cumin, smoked paprika, chipotle, and oregano. Stir and cook for 1 minute until fragrant.', timerMinutes: 1 },
      { order: 3, instruction: 'Add black beans, vegetable broth, diced tomatoes, and salt. Bring to a boil, then reduce heat and simmer for 30 minutes.', timerMinutes: 30 },
      { order: 4, instruction: 'Using an immersion blender, blend about half of the soup until partially smooth while leaving some whole beans for texture. Alternatively, transfer 2 cups to a blender, puree, and return to the pot.', timerMinutes: null },
      { order: 5, instruction: 'Stir in the lime juice. Taste and adjust salt and spice level.', timerMinutes: null },
      { order: 6, instruction: 'Ladle into bowls and top with diced avocado, fresh cilantro, and a dollop of crema. Serve with tortilla chips or warm cornbread.', timerMinutes: null },
    ],
    notes: 'For a completely smooth soup, blend the entire pot. Using dried beans instead of canned takes longer but gives a creamier texture: soak 1 pound overnight and simmer for 1.5 hours before adding the chile and spice base.',
    communityRating: 4.3,
    communityRatingCount: 190,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },

  // ==================== CARIBBEAN (3) ====================
  {
    title: 'Jerk Chicken',
    description:
      'Intensely spiced, smoky chicken marinated in a fiery Scotch bonnet and allspice paste, then grilled until the skin is charred and the meat is impossibly juicy. This iconic Jamaican dish is a flavor explosion you will crave again and again.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jerk-chicken.jpg', caption: 'Grilled jerk chicken with charred edges', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jerk-chicken-prep.jpg', caption: 'Chicken marinating in jerk paste', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 40,
    totalTime: 60,
    difficulty: 'medium',
    spiceLevel: 4,
    cuisine: 'Jamaican',
    region: 'Caribbean',
    country: 'Jamaica',
    categories: ['Dinner'],
    tags: ['grilling', 'high-protein', 'gluten-free', 'dairy-free', 'make-ahead', 'party'],
    ageGroups: ['adult'],
    nutrition: {
      calories: 380,
      protein: 40,
      carbs: 8,
      fat: 20,
      fiber: 2,
      sugar: 4,
      sodium: 720,
      iron: 2.5,
    },
    ingredients: [
      { qty: 3, unit: 'lb', item: 'chicken leg quarters (or thighs and drumsticks)', group: 'Chicken' },
      { qty: 6, unit: '', item: 'green onions (scallions), roughly chopped', group: 'Jerk Marinade' },
      { qty: 2, unit: '', item: 'Scotch bonnet peppers, seeded (keep seeds for more heat)', group: 'Jerk Marinade' },
      { qty: 4, unit: 'cloves', item: 'garlic', group: 'Jerk Marinade' },
      { qty: 1, unit: 'tbsp', item: 'fresh thyme leaves', group: 'Jerk Marinade' },
      { qty: 2, unit: 'tbsp', item: 'soy sauce', group: 'Jerk Marinade' },
      { qty: 2, unit: 'tbsp', item: 'lime juice', group: 'Jerk Marinade' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Jerk Marinade' },
      { qty: 1, unit: 'tbsp', item: 'brown sugar', group: 'Jerk Marinade' },
      { qty: 1.5, unit: 'tsp', item: 'ground allspice', group: 'Jerk Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Jerk Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'ground nutmeg', group: 'Jerk Marinade' },
      { qty: 1, unit: 'tsp', item: 'black pepper', group: 'Jerk Marinade' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Jerk Marinade' },
    ],
    steps: [
      { order: 1, instruction: 'Blend all the jerk marinade ingredients in a food processor until a thick paste forms. Wear gloves when handling the Scotch bonnets.', timerMinutes: null },
      { order: 2, instruction: 'Score the chicken pieces with deep cuts. Rub the jerk paste all over and into the cuts. Marinate in the fridge for at least 4 hours, ideally overnight.', timerMinutes: null },
      { order: 3, instruction: 'Preheat a grill to medium heat (around 350 degrees F) with indirect and direct zones. Place the chicken on the indirect heat side, skin-side up, and close the lid.', timerMinutes: null },
      { order: 4, instruction: 'Cook with the lid closed for 30 minutes, turning once halfway through.', timerMinutes: 30 },
      { order: 5, instruction: 'Move the chicken to direct heat and grill for 5-8 minutes per side until the skin is charred and the internal temperature at the thickest part reads 175 degrees F.', timerMinutes: 10 },
      { order: 6, instruction: 'Let rest for 5 minutes, then serve with rice and peas, festival (fried dumplings), or coleslaw.', timerMinutes: 5 },
    ],
    notes: 'The longer you marinate, the better. Scotch bonnet heat varies, so start with one pepper if you are sensitive to spice. Traditionally this is cooked over pimento (allspice) wood, which adds a distinct smoky flavor. Adding soaked wood chips to your grill mimics this.',
    communityRating: 4.8,
    communityRatingCount: 320,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Rice and Peas',
    description:
      'Fluffy coconut rice simmered with kidney beans, fragrant thyme, allspice, and Scotch bonnet pepper. This beloved Jamaican side dish is deeply aromatic and the traditional partner to jerk chicken or any Caribbean meal.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/rice-and-peas.jpg', caption: 'Bowl of Jamaican rice and peas', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/rice-and-peas-prep.jpg', caption: 'Coconut milk being poured over rice and beans', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 10,
    cookTime: 35,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 1,
    cuisine: 'Jamaican',
    region: 'Caribbean',
    country: 'Jamaica',
    categories: ['Sides', 'Dinner'],
    tags: ['one-pot', 'vegan', 'gluten-free', 'dairy-free', 'budget-friendly', 'high-fiber'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 340,
      protein: 10,
      carbs: 52,
      fat: 10,
      fiber: 6,
      sugar: 2,
      sodium: 420,
      iron: 3.0,
    },
    ingredients: [
      { qty: 2, unit: 'cups', item: 'long-grain white rice', group: 'Rice' },
      { qty: 1, unit: 'can (13.5 oz)', item: 'coconut milk', group: 'Liquid' },
      { qty: 1.5, unit: 'cups', item: 'water', group: 'Liquid' },
      { qty: 1, unit: 'can (15 oz)', item: 'red kidney beans, drained and rinsed', group: 'Beans' },
      { qty: 3, unit: 'sprigs', item: 'fresh thyme', group: 'Seasonings' },
      { qty: 3, unit: '', item: 'whole allspice berries', group: 'Seasonings' },
      { qty: 1, unit: '', item: 'whole Scotch bonnet pepper (kept whole, not pierced)', group: 'Seasonings' },
      { qty: 2, unit: '', item: 'green onions (scallions)', group: 'Seasonings' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Seasonings' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Seasonings' },
    ],
    steps: [
      { order: 1, instruction: 'Rinse the rice in a fine-mesh strainer under cold water until the water runs clear.', timerMinutes: null },
      { order: 2, instruction: 'In a medium pot, combine the coconut milk, water, kidney beans, thyme, allspice berries, whole Scotch bonnet pepper, green onions, garlic, salt, and pepper. Bring to a boil.', timerMinutes: null },
      { order: 3, instruction: 'Add the rinsed rice and stir once. Reduce the heat to the lowest setting, cover tightly with a lid, and cook for 20 minutes. Do not lift the lid during cooking.', timerMinutes: 20 },
      { order: 4, instruction: 'Turn off the heat and let the rice steam, still covered, for an additional 10 minutes.', timerMinutes: 10 },
      { order: 5, instruction: 'Remove the lid and carefully take out the whole Scotch bonnet (it should still be intact), thyme sprigs, allspice berries, and green onions. Fluff the rice with a fork and serve.', timerMinutes: null },
    ],
    notes: 'The Scotch bonnet is left whole to infuse flavor without heat. If it bursts, the rice will be very spicy. Traditional Jamaican rice and peas uses dried kidney beans soaked overnight and cooked first, which gives a richer flavor to the cooking liquid.',
    communityRating: 4.4,
    communityRatingCount: 200,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Jamaican Beef Patties',
    description:
      'Flaky, golden turmeric-tinted pastry shells filled with savory, spiced ground beef seasoned with Scotch bonnet, thyme, and curry powder. These handheld Jamaican favorites are the ultimate street food snack.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jamaican-beef-patties.jpg', caption: 'Golden Jamaican beef patties on a plate', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jamaican-beef-patties-prep.jpg', caption: 'Filling being spooned onto dough rounds', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 40,
    cookTime: 30,
    totalTime: 70,
    difficulty: 'hard',
    spiceLevel: 3,
    cuisine: 'Jamaican',
    region: 'Caribbean',
    country: 'Jamaica',
    categories: ['Snacks', 'Lunch', 'Appetizers'],
    tags: ['baking', 'make-ahead', 'freezer-friendly', 'lunchbox', 'party', 'high-protein'],
    ageGroups: ['teen', 'adult'],
    nutrition: {
      calories: 380,
      protein: 16,
      carbs: 32,
      fat: 22,
      fiber: 2,
      sugar: 2,
      sodium: 560,
      iron: 3.5,
    },
    ingredients: [
      { qty: 3, unit: 'cups', item: 'all-purpose flour', group: 'Pastry' },
      { qty: 1.5, unit: 'tsp', item: 'turmeric', group: 'Pastry' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Pastry' },
      { qty: 0.75, unit: 'cup', item: 'cold unsalted butter, cubed', group: 'Pastry' },
      { qty: 0.5, unit: 'cup', item: 'ice water', group: 'Pastry' },
      { qty: 1, unit: 'lb', item: 'ground beef', group: 'Filling' },
      { qty: 1, unit: 'tbsp', item: 'vegetable oil', group: 'Filling' },
      { qty: 1, unit: '', item: 'small yellow onion, finely diced', group: 'Filling' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Filling' },
      { qty: 1, unit: '', item: 'Scotch bonnet pepper, seeded and minced', group: 'Filling' },
      { qty: 2, unit: 'tsp', item: 'curry powder', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'fresh thyme leaves', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'allspice', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'beef broth', group: 'Filling' },
      { qty: 0.25, unit: 'cup', item: 'breadcrumbs', group: 'Filling' },
      { qty: 1, unit: '', item: 'egg, beaten (for egg wash)', group: 'Assembly' },
    ],
    steps: [
      { order: 1, instruction: 'Make the pastry: Whisk flour, turmeric, and salt in a large bowl. Cut in the cold butter with a pastry cutter or fork until the mixture resembles coarse crumbs. Add ice water a tablespoon at a time until the dough comes together. Flatten into a disc, wrap in plastic, and refrigerate for 30 minutes.', timerMinutes: 30 },
      { order: 2, instruction: 'Heat oil in a skillet over medium-high heat. Cook onion for 3 minutes, then add garlic and Scotch bonnet. Cook 1 minute. Add beef, breaking it up, and cook until browned, about 5 minutes.', timerMinutes: 9 },
      { order: 3, instruction: 'Add curry powder, thyme, allspice, salt, pepper, and beef broth. Simmer for 10 minutes until most liquid is absorbed. Stir in breadcrumbs to bind the filling. Let cool completely.', timerMinutes: 10 },
      { order: 4, instruction: 'Preheat oven to 400 degrees F. Roll out the dough to 1/8-inch thickness. Cut into 6-inch circles using a plate or large cutter.', timerMinutes: null },
      { order: 5, instruction: 'Place about 3 tablespoons of filling on one half of each circle. Fold the other half over and press the edges firmly with a fork to seal. Place on a parchment-lined baking sheet.', timerMinutes: null },
      { order: 6, instruction: 'Brush the tops with beaten egg. Bake for 25-30 minutes until golden brown and flaky.', timerMinutes: 28 },
    ],
    notes: 'These freeze beautifully before or after baking. Freeze unbaked patties on a sheet pan, then transfer to a bag. Bake from frozen, adding 5-8 minutes to the baking time. The filling must be completely cool before assembling or it will melt the pastry.',
    communityRating: 4.5,
    communityRatingCount: 160,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },

  // ==================== BRAZILIAN (3) ====================
  {
    title: 'Feijoada',
    description:
      'Brazil\'s beloved national dish: a rich, deeply savory black bean stew slow-simmered with smoked pork, sausage, and beef, served over fluffy white rice with crispy collard greens and orange slices. A celebration of bold, smoky flavors.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/feijoada.jpg', caption: 'Feijoada served with rice, farofa, and collard greens', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/feijoada-prep.jpg', caption: 'Black beans and smoked meats ready to simmer', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 30,
    cookTime: 180,
    totalTime: 210,
    difficulty: 'hard',
    spiceLevel: 1,
    cuisine: 'Brazilian',
    region: 'Americas',
    country: 'Brazil',
    categories: ['Dinner', 'Soups & Stews'],
    tags: ['one-pot', 'high-protein', 'high-iron', 'gluten-free', 'dairy-free', 'batch-cooking', 'sunday-dinner', 'celebration'],
    ageGroups: ['adult'],
    nutrition: {
      calories: 580,
      protein: 42,
      carbs: 38,
      fat: 28,
      fiber: 12,
      sugar: 3,
      sodium: 1050,
      iron: 6.5,
    },
    ingredients: [
      { qty: 1, unit: 'lb', item: 'dried black beans, soaked overnight and drained', group: 'Beans' },
      { qty: 0.75, unit: 'lb', item: 'smoked pork ribs, cut into pieces', group: 'Meats' },
      { qty: 0.5, unit: 'lb', item: 'smoked sausage (linguica or kielbasa), sliced', group: 'Meats' },
      { qty: 0.5, unit: 'lb', item: 'slab bacon, cut into chunks', group: 'Meats' },
      { qty: 0.5, unit: 'lb', item: 'beef stew meat, cubed', group: 'Meats' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Base' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Base' },
      { qty: 6, unit: 'cloves', item: 'garlic, minced', group: 'Base' },
      { qty: 3, unit: '', item: 'bay leaves', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'black pepper', group: 'Seasonings' },
      { qty: 1, unit: 'tsp', item: 'salt (adjust to taste)', group: 'Seasonings' },
      { qty: 6, unit: 'cups', item: 'water', group: 'Liquid' },
      { qty: 4, unit: 'cups', item: 'cooked white rice, for serving', group: 'Sides' },
      { qty: 1, unit: 'bunch', item: 'collard greens, thinly sliced', group: 'Sides' },
      { qty: 2, unit: '', item: 'oranges, sliced into rounds', group: 'Sides' },
      { qty: 1, unit: 'cup', item: 'farofa (toasted cassava flour), for serving', group: 'Sides' },
    ],
    steps: [
      { order: 1, instruction: 'In a large pot or Dutch oven, combine the soaked and drained black beans, smoked pork ribs, bacon, and beef stew meat. Add water to cover by 2 inches. Bring to a boil, then reduce to a simmer. Cook for 1.5 hours, skimming any foam.', timerMinutes: 90 },
      { order: 2, instruction: 'In a separate skillet, heat olive oil over medium heat. Cook the onion for 5 minutes until soft. Add garlic and cook for 1 minute. Add a ladle of beans to the skillet and mash roughly. Stir this mixture back into the main pot.', timerMinutes: null },
      { order: 3, instruction: 'Add the sliced sausage, bay leaves, cumin, and pepper to the pot. Continue simmering for another 1 to 1.5 hours until the beans are very tender and the broth is thick and creamy.', timerMinutes: 75 },
      { order: 4, instruction: 'While the feijoada finishes, saute the thinly sliced collard greens in a tablespoon of olive oil with a pinch of salt over high heat for 3-4 minutes until just wilted but still bright green.', timerMinutes: 4 },
      { order: 5, instruction: 'Remove bay leaves. Taste and adjust the salt. The broth should be thick and rich.', timerMinutes: null },
      { order: 6, instruction: 'Serve the feijoada in deep bowls alongside white rice, sauteed collard greens, orange slices, and farofa. The orange slices are traditionally eaten between bites to cut the richness.', timerMinutes: null },
    ],
    notes: 'Feijoada is traditionally a Saturday lunch dish in Brazil, often shared with family and friends. It tastes even better reheated the next day. If you cannot find linguica, any good smoked sausage works. Soak the beans the night before for the best texture.',
    communityRating: 4.6,
    communityRatingCount: 140,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Pao de Queijo',
    description:
      'Impossibly chewy, golden Brazilian cheese bread balls made with tapioca flour and loaded with salty Parmesan. Crispy on the outside, gloriously stretchy and hollow inside, these addictive puffs vanish the moment they leave the oven.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pao-de-queijo.jpg', caption: 'Basket of golden pao de queijo', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pao-de-queijo-prep.jpg', caption: 'Dough balls on a baking sheet before baking', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'Brazilian',
    region: 'Americas',
    country: 'Brazil',
    categories: ['Snacks', 'Baking', 'Breakfast'],
    tags: ['gluten-free', 'vegetarian', 'under-30-min', 'family-friendly', 'freezer-friendly', 'party'],
    ageGroups: ['toddler', 'kid', 'teen', 'adult'],
    nutrition: {
      calories: 220,
      protein: 8,
      carbs: 26,
      fat: 10,
      fiber: 0,
      sugar: 1,
      sodium: 320,
      iron: 0.5,
    },
    ingredients: [
      { qty: 2, unit: 'cups', item: 'tapioca flour (tapioca starch)', group: 'Dough' },
      { qty: 0.5, unit: 'cup', item: 'whole milk', group: 'Dough' },
      { qty: 0.25, unit: 'cup', item: 'vegetable oil', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 2, unit: '', item: 'large eggs', group: 'Dough' },
      { qty: 1.5, unit: 'cups', item: 'finely grated Parmesan cheese (or Minas cheese)', group: 'Dough' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 400 degrees F. Line a baking sheet with parchment paper.', timerMinutes: null },
      { order: 2, instruction: 'In a saucepan, combine the milk, oil, and salt. Bring to a boil, then immediately remove from heat. Pour in all the tapioca flour and stir vigorously with a wooden spoon until a thick, sticky dough forms.', timerMinutes: null },
      { order: 3, instruction: 'Transfer the dough to a mixing bowl and let it cool for 5 minutes. Add the eggs one at a time, mixing well after each addition until fully incorporated. The dough will be sticky and stretchy.', timerMinutes: 5 },
      { order: 4, instruction: 'Mix in the grated Parmesan cheese until evenly distributed throughout the dough.', timerMinutes: null },
      { order: 5, instruction: 'With lightly oiled hands, roll the dough into 1.5-inch balls and place them on the prepared baking sheet about 2 inches apart.', timerMinutes: null },
      { order: 6, instruction: 'Bake for 20-25 minutes until puffed up and golden brown on the outside. They should be hollow and chewy inside. Serve warm.', timerMinutes: 22 },
    ],
    notes: 'These can be frozen before baking: freeze the shaped balls on a sheet pan, then transfer to a bag. Bake from frozen at 400 degrees F for 28-30 minutes. Traditional Brazilian recipes use queijo Minas, but Parmesan is the most accessible substitute.',
    communityRating: 4.5,
    communityRatingCount: 230,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
  {
    title: 'Acai Bowl',
    description:
      'A thick, frosty blend of acai berry puree and banana, topped with crunchy granola, sliced tropical fruits, coconut, and a drizzle of honey. This vibrant Brazilian superfood bowl is a refreshing, energizing start to the day.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/acai-bowl.jpg', caption: 'Colorful acai bowl with toppings', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/acai-bowl-prep.jpg', caption: 'Frozen acai packets and fresh fruit', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 2,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,
    cuisine: 'Brazilian',
    region: 'Americas',
    country: 'Brazil',
    categories: ['Breakfast', 'Snacks', 'Drinks & Smoothies'],
    tags: ['no-cook', 'vegan', 'gluten-free', 'dairy-free', 'under-15-min', 'high-fiber', 'low-sodium'],
    ageGroups: ['kid', 'teen', 'adult'],
    nutrition: {
      calories: 340,
      protein: 6,
      carbs: 58,
      fat: 12,
      fiber: 8,
      sugar: 32,
      sodium: 45,
      iron: 2.0,
    },
    ingredients: [
      { qty: 2, unit: 'packets (3.5 oz each)', item: 'frozen acai puree (unsweetened)', group: 'Base' },
      { qty: 1, unit: '', item: 'ripe banana (frozen)', group: 'Base' },
      { qty: 0.5, unit: 'cup', item: 'frozen mixed berries', group: 'Base' },
      { qty: 0.5, unit: 'cup', item: 'almond milk or coconut water', group: 'Base' },
      { qty: 0.5, unit: 'cup', item: 'granola', group: 'Toppings' },
      { qty: 1, unit: '', item: 'banana, sliced', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'sliced strawberries', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'fresh blueberries', group: 'Toppings' },
      { qty: 2, unit: 'tbsp', item: 'unsweetened shredded coconut', group: 'Toppings' },
      { qty: 2, unit: 'tbsp', item: 'honey or agave nectar', group: 'Toppings' },
      { qty: 1, unit: 'tbsp', item: 'chia seeds', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Run the frozen acai packets under warm water for 10 seconds, then break them into pieces into a high-speed blender.', timerMinutes: null },
      { order: 2, instruction: 'Add the frozen banana, frozen berries, and almond milk to the blender. Blend on low speed, using the tamper to push ingredients down, until very thick and smooth. The consistency should be much thicker than a smoothie.', timerMinutes: null },
      { order: 3, instruction: 'Divide the acai mixture between two bowls, spreading it evenly.', timerMinutes: null },
      { order: 4, instruction: 'Arrange the toppings in rows: granola, sliced banana, strawberries, blueberries, and shredded coconut. Drizzle with honey and sprinkle chia seeds on top.', timerMinutes: null },
      { order: 5, instruction: 'Serve immediately before the base melts. Eat with a spoon.', timerMinutes: null },
    ],
    notes: 'The key to a thick bowl is using minimal liquid and all frozen fruit. If the blender struggles, add liquid just one tablespoon at a time. Use unsweetened acai packets to control the sugar content. In Brazil, acai bowls (acai na tigela) are often served with guarana syrup instead of honey.',
    communityRating: 4.3,
    communityRatingCount: 180,
    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-01').toISOString(),
  },
];

export default americasRecipes;
